import React from 'react';

export const CATEGORIES = [{
    label: 'Politics',
    className: 'politics'
}, {
    label: 'Breaking News',
    className: 'breaking'
}, {
    label: 'Sports',
    className: 'sports'
}, {
    label: 'Opinion',
    className: 'opinion'
}, {
    label: 'Justice & Rights',
    className: 'justice',
}, {
    label: 'Entertainment',
    className: 'entertainment'
}, {
    label: 'Culture',
    className: 'culture'
}];

export const MEDIUMS = [{
    label: 'Longform',
    className: 'longform',
    description: (
        <div>
            <p>Longform pieces build narratives using longer word counts, engaging readers in immersive storytelling.</p>
            <p>In a world where attention is scarce, 2016 proved that longform content still has a strong role in engaging and moving readers, with articles on Tiger Woods, 9/11, and El Chapo leading in the longform category. While last year’s overall top story was The Atlantic’s longform piece, What ISIS Really Wants, with 3:00+ minutes of average engaged time, longform was pushed to just outside of the top 10 this year.</p>
        </div>
    ),
}, {
    label: 'Interactive',
    className: 'interactive',
    description: (
        <div>
            <p>Interactives are digital experiences meant for user exploration.</p>
            <p>In many ways, this was the Year of the Interactive, with election prediction pages and live results pages captivating our attention and driving a massive number of engaged, repeat visitors. The top story, 538’s General Election predictor, received more engaged time than the top five stories of 2015 combined.</p>
        </div>
    ),
}, {
    label: 'Live Blog',
    className: 'blog',
    description: (
        <div>
            <p>Live Blogs follow events as they happen and are updated live as new information comes in.</p>
            <p>Live blogs proved incredibly successful for covering the US election, EU Referendum, presidential debates, and other high-interest events such as the Summer Olympics in Rio. The BBC in particular took a strong stance in using the live-blog format consistently across their site, from politics to breaking news to sports, and quite clearly this choice was a successful one for engaging audiences.</p>
        </div>
    ),
}];

let categoryMap = {};
CATEGORIES.forEach((category) => {
  categoryMap[category.label] = category;
})

let categoryClassMap = {};
CATEGORIES.forEach((category) => {
  categoryClassMap[category.className] = category;
})

export const CATEGORY_MAP = categoryMap;
export const CATEGORY_CLASS_MAP = categoryClassMap;

export const CATEGORY_CLASSES = CATEGORIES.map(function(category) { return category.className; })
export const MEDIUM_CLASSES = MEDIUMS.map(function(medium){ return medium.className; });



// WEBPACK FOOTER //
// ./src/utils/category-utils.js